export default __webpack_public_path__ + "static/media/propeller-logo.93d7594f.svg";